/* The studio footer piece (prototype: .siteFooter, guest). Colors are theme tokens only. */
@layer telify {
  .footer {
    border-top: var(--line);
    margin-top: 96px;
  }

  /* A page that ends on a tinted band (the home's Open times) meets the footer with no gap, as the prototype's home does. */
  :global(main):has([data-band]:last-child) + .footer {
    margin-top: 0;
  }

  .grid {
    padding: 40px 0 44px;
    display: grid;
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .cols2 {
    grid-template-columns: 1.4fr 1fr;
  }

  .cols3 {
    grid-template-columns: 1.4fr 1fr 1fr;
  }

  /* Signed in: Book, Your account and Find us beside the studio's mark. */
  .cols4 {
    grid-template-columns: 1.4fr 1fr 1fr 1fr;
  }

  /* Messages opens the panel: a button drawn as the other links. */
  .linkButton {
    appearance: none;
    border: 0;
    background: none;
    padding: 0;
    font: inherit;
    color: inherit;
    cursor: pointer;
  }

  .mark {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    max-width: 100%;
  }

  .logo {
    flex-shrink: 0;
    display: block;
    width: 36px;
    height: 36px;
    object-fit: contain;
  }

  .name {
    font-family: var(--font-display);
    font-weight: 600;
    font-size: 22px;
    letter-spacing: -0.01em;
    overflow-wrap: anywhere;
  }

  .wordmark {
    font-size: 23px;
    letter-spacing: 0;
  }

  .blurb {
    margin-top: 12px;
    font-size: 14px;
    color: var(--text-tertiary);
    line-height: 1.6;
    max-width: 34ch;
  }

  .head {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--text-tertiary);
    margin-bottom: 12px;
  }

  .list {
    list-style: none;
    display: grid;
    gap: 8px;
    font-size: 14px;
    color: var(--text-secondary);
    overflow-wrap: anywhere;
  }

  .small {
    grid-column: 1 / -1;
    padding-top: 20px;
    border-top: 1px solid var(--border-subtle);
    font-size: 12.5px;
    color: var(--text-muted);
  }

  @media (hover: hover) {
    .list a:hover,
    .linkButton:hover {
      color: var(--text-primary);
    }
  }

  @media (max-width: 1023px) {
    .cols2,
    .cols3,
    .cols4 {
      grid-template-columns: 1fr;
    }
  }
}
